/* assets/product-reviews.js
   The "Write a Review" button defers to whichever review app is
   installed (Judge.me exposes `window.jdgm`, Loox exposes
   `window.LoxJsInterface` style globals) so merchants don't get a dead
   button if they later switch review_source to "app". Falls back to
   scrolling to the manual review grid / a mailto if no app is detected. */

(function () {
  'use strict';

  function handleWriteReview(section) {
    if (window.jdgm && typeof window.jdgm.openReviewForm === 'function') {
      window.jdgm.openReviewForm();
      return;
    }
    var appWidget = section.querySelector('[data-app-review-widget]');
    if (appWidget) {
      var writeLink = appWidget.querySelector('a, button');
      if (writeLink) {
        writeLink.click();
        return;
      }
    }
    var list = section.querySelector('.lw-reviews__list-col');
    if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function boot() {
    document.querySelectorAll('.lw-reviews').forEach(function (section) {
      var btn = section.querySelector('[data-write-review]');
      if (btn) btn.addEventListener('click', function () { handleWriteReview(section); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
